(function($) {
  'use strict';
  
  function initializeDeliveryDate() {
    
    // 要素の存在チェック（より柔軟に）
    const $deliveryDateInput = $('#delivery-date');
    const $deliveryTimeInput = $('#delivery-time');
    
    // 配達日指定セクション全体の存在チェック
    const $deliverySection = $('.cart-delivery-date');
    
    if ($deliverySection.length === 0) {
      if (Shopify.designMode) console.log('配達日指定セクションが見つかりません');
      return;
    }
    
    // 要素が見つからない場合でも初期化を続行（後で要素が動的に追加される可能性を考慮）
    if ($deliveryDateInput.length === 0) {
      if (Shopify.designMode) console.warn('delivery-date要素が見つかりません。後で再試行します。');
    }
    if ($deliveryTimeInput.length === 0) {
      if (Shopify.designMode) console.warn('delivery-time要素が見つかりません。後で再試行します。');
    }
    
    let updateTimer;
    let holidaysCache = [];
    let currentCartGroup = null; // カートグループを保持
    
    // 日付を正規化する関数（時間を0:00:00にセット）
    function normalizeDate(date) {
      const normalized = new Date(date);
      normalized.setHours(0, 0, 0, 0);
      return normalized;
    }
    
    // 毎年の長期休暇設定（月-日形式）
    const annualHolidays = [
      // 年末年始
      { start: '12-26', end: '01-06', name: '年末年始休業' },
      // お盆休み
      { start: '08-11', end: '08-19', name: 'お盆休業' },
      // ゴールデンウィーク
      { start: '04-27', end: '05-07', name: 'GW休業' }
    ];

    // 商品グループ別設定（product-group-settings JSONから動的読み込み + フォールバック）
    const productGroupConfig = loadProductGroupConfig();

    function loadProductGroupConfig() {
      const settingsEl = document.getElementById('product-group-settings');
      if (!settingsEl) {
        // フォールバック: 最低限のdefault設定
        return {
          'default': {
            type: 'simple_days', daysAfter: 7, maxDays: 28, skipNonBusinessDays: true,
            infoTitle: '配送について',
            infoList: ['7営業日後からお選びいただけます', '長期休暇期間は発送をお休みしております', 'ご希望に添えない場合もございます']
          }
        };
      }

      try {
        const data = JSON.parse(settingsEl.textContent);
        const config = {};

        // デフォルト設定
        config['default'] = data.defaultDeliveryConfig || {
          type: 'simple_days', daysAfter: 7, maxDays: 28, skipNonBusinessDays: true,
          infoTitle: '配送について',
          infoList: ['7営業日後からお選びいただけます']
        };

        // 各グループの配送設定を読み込み
        if (data.groups) {
          data.groups.forEach(function(group) {
            if (group.key && group.deliveryConfig) {
              config[group.key] = group.deliveryConfig;
            }
          });
        }

        return config;
      } catch (e) {
        if (Shopify.designMode) console.warn('商品グループ設定の読み込みに失敗:', e);
        return {
          'default': {
            type: 'simple_days', daysAfter: 7, maxDays: 28, skipNonBusinessDays: true,
            infoTitle: '配送について',
            infoList: ['7営業日後からお選びいただけます']
          }
        };
      }
    }

    // 注: specialShippingScheduleは廃止。productGroupConfig経由でグループ別設定を参照。
    
    // 日本の祝日API（内閣府提供）から祝日を取得
    async function fetchHolidays(year) {
      try {
        // 日本の祝日API（無料）
        const response = await fetch(`https://holidays-jp.github.io/api/v1/${year}/date.json`);
        if (response.ok) {
          const holidays = await response.json();
          return Object.keys(holidays).map(date => ({
            date: date,
            name: holidays[date]
          }));
        }
      } catch (error) {
        if (Shopify.designMode) console.warn('祝日の取得に失敗しました:', error);
      }
      
      // フォールバック：主要な祝日を手動設定
      return getFallbackHolidays(year);
    }
    
    // フォールバック用の主要祝日
    function getFallbackHolidays(year) {
      return [
        { date: `${year}-01-01`, name: '元日' },
        { date: `${year}-02-11`, name: '建国記念の日' },
        { date: `${year}-04-29`, name: '昭和の日' },
        { date: `${year}-05-03`, name: '憲法記念日' },
        { date: `${year}-05-04`, name: 'みどりの日' },
        { date: `${year}-05-05`, name: 'こどもの日' },
        { date: `${year}-11-03`, name: '文化の日' },
        { date: `${year}-11-23`, name: '勤労感謝の日' },
      ];
    }
    
    // 年間休暇期間かどうかをチェック
    function isAnnualHoliday(date) {
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const currentDate = `${month}-${day}`;
      const year = date.getFullYear();
      
      for (const holiday of annualHolidays) {
        let startDate = holiday.start;
        let endDate = holiday.end;
        
        // 年をまたぐ場合の処理（年末年始など）
        if (startDate > endDate) {
          // 年末年始の場合
          if (currentDate >= startDate || currentDate <= endDate) {
            return { isHoliday: true, name: holiday.name };
          }
        } else {
          // 通常の期間
          if (currentDate >= startDate && currentDate <= endDate) {
            return { isHoliday: true, name: holiday.name };
          }
        }
      }
      
      return { isHoliday: false };
    }
    
    // 祝日かどうかをチェック
    function isNationalHoliday(date) {
      const dateStr = date.toISOString().split('T')[0];
      const holiday = holidaysCache.find(h => h.date === dateStr);
      return holiday ? { isHoliday: true, name: holiday.name } : { isHoliday: false };
    }
    
    // 発送不可日かどうかを総合判定（営業日チェック用）
    function isShippingUnavailable(date) {
      // 土日のチェック
      const dayOfWeek = date.getDay();
      if (dayOfWeek === 0 || dayOfWeek === 6) {
        return { unavailable: true, reason: '土日' };
      }
      
      // 年間休暇のチェック
      const annualCheck = isAnnualHoliday(date);
      if (annualCheck.isHoliday) {
        return { unavailable: true, reason: annualCheck.name };
      }
      
      // 祝日のチェック
      const holidayCheck = isNationalHoliday(date);
      if (holidayCheck.isHoliday) {
        return { unavailable: true, reason: holidayCheck.name };
      }
      
      return { unavailable: false };
    }

    // カートグループを取得
    async function getCurrentCartGroup() {
      try {
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        
        if (cart.items.length === 0) {
          return 'default';
        }

        // 最初の商品のグループを確認
        const firstItem = cart.items[0];
        const productHandle = firstItem.handle || firstItem.product_handle;
        
        if (productHandle) {
          const productResponse = await fetch(`/products/${productHandle}.js`);
          const product = await productResponse.json();
          
          // group_プレフィックスが付いたタグを探す
          const groupTag = product.tags.find(tag => tag.startsWith('group_'));
          return groupTag ? groupTag.replace('group_', '') : 'default';
        }
      } catch (error) {
        if (Shopify.designMode) console.error('カートグループの取得に失敗:', error);
      }
      return 'default';
    }

    // 次の指定曜日を取得
    function getNextWeekday(fromDate, targetDayOfWeek) {
      const result = new Date(fromDate);
      const currentDayOfWeek = result.getDay();
      let daysToAdd = targetDayOfWeek - currentDayOfWeek;
      
      if (daysToAdd <= 0) {
        daysToAdd += 7;
      }
      
      result.setDate(result.getDate() + daysToAdd);
      return normalizeDate(result);
    }

    // 今週の指定曜日を取得（過去日でも取得）
    function getThisWeekday(fromDate, targetDayOfWeek) {
      const result = new Date(fromDate);
      const currentDayOfWeek = result.getDay();
      let daysToAdd = targetDayOfWeek - currentDayOfWeek;
      
      result.setDate(result.getDate() + daysToAdd);
      return normalizeDate(result);
    }

    // 指定週の指定曜日を取得
    function getWeekdayInSameWeek(referenceDate, targetDayOfWeek) {
      const result = new Date(referenceDate);
      const referenceDayOfWeek = result.getDay();
      let daysToAdd = targetDayOfWeek - referenceDayOfWeek;
      
      result.setDate(result.getDate() + daysToAdd);
      return normalizeDate(result);
    }

    // 指定した期間内の日付かチェック
    function isDateInPeriod(date, period, year) {
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const dateStr = `${month}-${day}`;
      
      const startDate = period.start;
      const endDate = period.end;
      
      if (startDate > endDate) {
        // 年をまたぐ期間
        return dateStr >= startDate || dateStr <= endDate;
      } else {
        // 通常の期間
        return dateStr >= startDate && dateStr <= endDate;
      }
    }

    // **通常商品用の発送可能日を計算（既存ロジック）**
    function getNextShippingDateBusiness(date, businessDaysAfter = 3) {
      let result = normalizeDate(new Date(date));
      let addedDays = 0;
      
      while (addedDays < businessDaysAfter) {
        result.setDate(result.getDate() + 1);
        
        const shippingCheck = isShippingUnavailable(result);
        if (!shippingCheck.unavailable) {
          addedDays++;
        }
      }
      
      return result;
    }

    // **発送日ベースの週次スケジュール（tenman用）**
    function getNextShippingDateShippingWeekly(orderDate, config) {
      const today = normalizeDate(orderDate);
      
      // 1. 注文締切日（今週または来週の木曜日）を特定
      let targetCutoffDate;
      if (today.getDay() === 5 || today.getDay() === 6 || today.getDay() === 0) {
        // 金土日の注文は来週の木曜締切
        targetCutoffDate = getNextWeekday(today, config.orderCutoffDay);
      } else if (today.getDay() <= 4) {
        // 月～木の注文は今週の木曜締切（まだ時間がある場合）
        const thisWeekCutoff = getThisWeekday(today, config.orderCutoffDay);
        targetCutoffDate = today <= thisWeekCutoff ? thisWeekCutoff : getNextWeekday(today, config.orderCutoffDay);
      }
      
      // 2. 発送依頼日（締切週の金曜日）を計算
      const requestDate = getWeekdayInSameWeek(targetCutoffDate, config.requestDay);
      
      // 金曜日が休業日の場合は次の営業日の金曜日に延期
      let actualRequestDate = requestDate;
      while (isShippingUnavailable(actualRequestDate).unavailable) {
        actualRequestDate = getNextWeekday(actualRequestDate, config.requestDay);
      }
      
      // 3. 発送開始日（発送依頼の次週水曜日）を計算
      const shippingStartDate = getNextWeekday(actualRequestDate, config.shippingDay);
      
      // 4. 配達開始日を計算（発送開始の翌日または長期休暇考慮で翌々日）
      const deliveryStartDate = new Date(shippingStartDate);
      
      // 発送開始日が長期休暇期間中かチェック
      const holidayCheck = isAnnualHoliday(shippingStartDate);
      if (holidayCheck.isHoliday) {
        // 長期休暇の場合は翌々日から配達開始
        deliveryStartDate.setDate(deliveryStartDate.getDate() + 2);
      } else {
        // 通常時は翌日から配達開始
        deliveryStartDate.setDate(deliveryStartDate.getDate() + config.deliveryStartOffset);
      }
      
      // 最短絶対日付制約がある場合
      let result = normalizeDate(deliveryStartDate);
      if (config.minAbsoluteDate) {
        const minAbsoluteDate = normalizeDate(new Date(config.minAbsoluteDate));
        if (result < minAbsoluteDate) {
          result = minAbsoluteDate;
        }
      }
      
      return result;
    }

    // **単純日数ベース（ending用・default用）**
    function getNextShippingDateSimpleDays(orderDate, config) {
      const today = normalizeDate(orderDate);
      
      if (config.skipNonBusinessDays) {
        // 営業日のみカウント
        let result = normalizeDate(new Date(today));
        let addedDays = 0;
        
        while (addedDays < config.daysAfter) {
          result.setDate(result.getDate() + 1);
          
          const shippingCheck = isShippingUnavailable(result);
          if (!shippingCheck.unavailable) {
            addedDays++;
          }
        }
        
        // 最短絶対日付制約がある場合（defaultグループ用）
        if (config.minAbsoluteDate) {
          const minAbsoluteDate = normalizeDate(new Date(config.minAbsoluteDate));
          if (result < minAbsoluteDate) {
            result = minAbsoluteDate;
          }
        }
        
        return result;
      } else {
        // 全日カウント（従来の動作）
        const deliveryDate = new Date(today);
        deliveryDate.setDate(deliveryDate.getDate() + config.daysAfter);
        
        // 最短絶対日付制約がある場合
        if (config.minAbsoluteDate) {
          const minAbsoluteDate = normalizeDate(new Date(config.minAbsoluteDate));
          const result = normalizeDate(deliveryDate);
          if (result < minAbsoluteDate) {
            return minAbsoluteDate;
          }
        }
        
        return normalizeDate(deliveryDate);
      }
    }

    // **発送依頼日からの日数範囲（group1用）**
    function getNextShippingDateRequestRange(orderDate, config) {
      const today = normalizeDate(orderDate);
      
      // 1. 注文締切日を特定
      let targetCutoffDate;
      if (today.getDay() === 5 || today.getDay() === 6 || today.getDay() === 0) {
        targetCutoffDate = getNextWeekday(today, config.orderCutoffDay);
      } else if (today.getDay() <= config.orderCutoffDay) {
        const thisWeekCutoff = getThisWeekday(today, config.orderCutoffDay);
        targetCutoffDate = today <= thisWeekCutoff ? thisWeekCutoff : getNextWeekday(today, config.orderCutoffDay);
      } else {
        targetCutoffDate = getNextWeekday(today, config.orderCutoffDay);
      }
      
      // 2. 発送依頼日を計算
      const requestDate = getWeekdayInSameWeek(targetCutoffDate, config.requestDay);
      
      // 3. 最短配達日（依頼日から最短日数後）
      const deliveryDate = new Date(requestDate);
      deliveryDate.setDate(deliveryDate.getDate() + config.minDaysFromRequest);
      
      return normalizeDate(deliveryDate);
    }

    // **到着日ベースの週次スケジュール（特定の曜日しか選択できない）**
    function getNextShippingDateDeliveryWeekly(orderDate, config) {
      const today = normalizeDate(orderDate);
      
      // 1. 注文日の次のrequestDay（木曜日）を取得
      const nextRequestDay = getNextWeekday(today, config.requestDay);
      
      // 2. requestDayの次の週の月曜日を取得
      const nextWeekMonday = new Date(nextRequestDay);
      nextWeekMonday.setDate(nextWeekMonday.getDate() + (7 - nextRequestDay.getDay() + 1));
      
      // 3. その週の最初のdeliveryDay（通常は水曜日）を取得
      let deliveryDate = new Date(nextWeekMonday);
      
      // deliveryDaysの中で最初に来る曜日を見つける
      const sortedDeliveryDays = [...config.deliveryDays].sort((a, b) => a - b);
      const targetDay = sortedDeliveryDays[0]; // 通常は水曜日（3）
      
      // 月曜日から目標の曜日までの日数を計算
      const daysToAdd = targetDay - 1; // 月曜日は1なので
      deliveryDate.setDate(deliveryDate.getDate() + daysToAdd);
      
      return normalizeDate(deliveryDate);
    }

    // **統合された発送日計算**
    function getNextShippingDate(orderDate, cartGroup) {
      const config = productGroupConfig[cartGroup];
      
      if (!config) {
        // 設定が見つからない場合はdefaultを使用
        return getNextShippingDateSimpleDays(orderDate, productGroupConfig.default);
      }
      
      switch (config.type) {
        case 'shipping_based_weekly':
          return getNextShippingDateShippingWeekly(orderDate, config);
        case 'simple_days':
          return getNextShippingDateSimpleDays(orderDate, config);
        case 'request_range':
          return getNextShippingDateRequestRange(orderDate, config);
        case 'delivery_based_weekly':
          return getNextShippingDateDeliveryWeekly(orderDate, config);
        default:
          // デフォルトは通常商品として処理
          return getNextShippingDateBusiness(orderDate, 3);
      }
    }

    // 最速配達日の表示更新
    function updateFastestDeliveryDate() {
      const fastestDeliveryDate = document.getElementById('fastest-delivery-date');
      if (fastestDeliveryDate) {
        const today = normalizeDate(new Date());
        const earliestDelivery = getNextShippingDate(today, currentCartGroup);
        
        // 日付を日本語形式でフォーマット
        const formattedDate = earliestDelivery.toLocaleDateString('ja-JP', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          weekday: 'short'
        });
        
        fastestDeliveryDate.textContent = formattedDate;
      }
    }

    // 配送情報の更新
    function updateDeliveryInfo() {
      const config = productGroupConfig[currentCartGroup] || productGroupConfig.default;
      
      // タイトルの更新（デスクトップ・モバイル両方）
      const titleElements = document.querySelectorAll('.cart-delivery-date__info-title');
      titleElements.forEach(element => {
        element.textContent = config.infoTitle;
      });
      
      // リストの更新（デスクトップ・モバイル両方）
      const listElements = document.querySelectorAll('.cart-delivery-date__info-list');
      listElements.forEach(list => {
        list.innerHTML = config.infoList.map(item => `<li>${item}</li>`).join('');
      });
    }
    
    // 配達可能日の範囲を計算（設定ベース）
    function getDeliveryDateRange(shippingDate, cartGroup) {
      const minDelivery = normalizeDate(new Date(shippingDate));
      const config = productGroupConfig[cartGroup];
      let maxDelivery;
      
      if (!config) {
        // 設定が見つからない場合はdefaultを使用
        const defaultConfig = productGroupConfig.default;
        maxDelivery = normalizeDate(new Date(shippingDate));
        maxDelivery.setDate(maxDelivery.getDate() + defaultConfig.maxDays);
      } else {
        // 設定のタイプに応じて最大配達日を計算
        switch (config.type) {
          case 'shipping_based_weekly':
          case 'delivery_based_weekly':
            // 月単位の配達期間
            maxDelivery = new Date(minDelivery);
            maxDelivery.setMonth(maxDelivery.getMonth() + config.deliveryMaxMonths);
            break;
          
          case 'simple_days':
            // 日数指定
            maxDelivery = normalizeDate(new Date(shippingDate));
            maxDelivery.setDate(maxDelivery.getDate() + config.maxDays); 
            break;
          
          case 'request_range':
            // 発送依頼日からの範囲計算
            // 最短日から最長日までの期間を配達期間とする
            const rangeDays = config.maxDaysFromRequest - config.minDaysFromRequest + 7; // 1週間の余裕
            maxDelivery = normalizeDate(new Date(shippingDate));
            maxDelivery.setDate(maxDelivery.getDate() + rangeDays);
            break;
          
          default:
            // デフォルト：14日後まで
            maxDelivery = normalizeDate(new Date(shippingDate));
            maxDelivery.setDate(maxDelivery.getDate() + 14);
        }
      }
      
      return { min: minDelivery, max: normalizeDate(maxDelivery) };
    }
    
    // 配達日が選択可能かチェック（設定ベース）
    function isDeliveryDateValid(deliveryDate) {
      const today = normalizeDate(new Date());
      const normalizedDeliveryDate = normalizeDate(deliveryDate);
      
      const earliestDelivery = getNextShippingDate(today, currentCartGroup);
      const deliveryRange = getDeliveryDateRange(earliestDelivery, currentCartGroup);
      if (Shopify.designMode) console.log("deliveryRange in isDeliveryDateValid:", deliveryRange);
      
      // 最短配達日より前はNG
      if (normalizedDeliveryDate < deliveryRange.min) {
        return { valid: false, reason: `最短配達日は${deliveryRange.min.toLocaleDateString('ja-JP')}です` };
      }
      
      // 最大配達日より後はNG
      if (normalizedDeliveryDate > deliveryRange.max) {
        const maxDateStr = deliveryRange.max.toLocaleDateString('ja-JP');
        return { valid: false, reason: `配達可能期間は${maxDateStr}までです` };
      }
      
      const config = productGroupConfig[currentCartGroup];
      
      if (!config) {
        // 設定が見つからない場合はdefaultを使用
        const defaultConfig = productGroupConfig.default;
        
        // defaultの場合はsimple_daysと同じロジック
        if (defaultConfig.skipNonBusinessDays) {
          const holidayCheck = isAnnualHoliday(normalizedDeliveryDate);
          if (holidayCheck.isHoliday) {
            return { valid: false, reason: `${holidayCheck.name}のため配達できません` };
          }
        }
        return { valid: true };
      }
      
      // 設定のタイプに応じた検証
      switch (config.type) {
        case 'shipping_based_weekly':
        case 'request_range':
          // これらのタイプは配達可能期間内であれば土日祝日でも配達可能
          return { valid: true };
        case 'simple_days':
          // skipNonBusinessDaysが有効な場合は長期休暇をチェック
          if (config.skipNonBusinessDays) {
            const holidayCheck = isAnnualHoliday(normalizedDeliveryDate);
            if (holidayCheck.isHoliday) {
              return { valid: false, reason: `${holidayCheck.name}のため配達できません` };
            }
          }
          return { valid: true };
        case 'delivery_based_weekly':
          // 指定された曜日かどうかをチェック
          const dayOfWeek = normalizedDeliveryDate.getDay();
          if (!config.deliveryDays.includes(dayOfWeek)) {
            const dayNames = config.deliveryDays.map(day => {
              const names = ['日', '月', '火', '水', '木', '金', '土'];
              return names[day];
            }).join('・');
            return { valid: false, reason: `配達可能日は${dayNames}曜日のみです` };
          }
          
          // requestDayの次週以降かどうかをチェック
          const nextRequestDay = getNextWeekday(today, config.requestDay);
          
          // requestDayの次の週の月曜日を取得
          const nextWeekMonday = new Date(nextRequestDay);
          nextWeekMonday.setDate(nextWeekMonday.getDate() + (7 - nextRequestDay.getDay() + 1));
          
          if (normalizedDeliveryDate < normalizeDate(nextWeekMonday)) {
            const requestDayName = ['日', '月', '火', '水', '木', '金', '土'][config.requestDay];
            return { valid: false, reason: `${requestDayName}曜日の翌週以降から選択可能です` };
          }
          
          return { valid: true };
        default:
          // 未知のタイプは通常商品として処理
          const requiredShippingDate = normalizeDate(new Date(normalizedDeliveryDate));
          requiredShippingDate.setDate(requiredShippingDate.getDate() - 1);
          
          const shippingCheck = isShippingUnavailable(requiredShippingDate);
          if (shippingCheck.unavailable) {
            return { valid: false, reason: `発送日が確保できません（${shippingCheck.reason}）` };
          }
          
          return { valid: true };
      }
    }

    // 祝日データの初期化
    async function initializeHolidays() {
      const currentYear = new Date().getFullYear();
      const nextYear = currentYear + 1;
      
      const currentYearHolidays = await fetchHolidays(currentYear);
      const nextYearHolidays = await fetchHolidays(nextYear);
      
      holidaysCache = [...currentYearHolidays, ...nextYearHolidays];
    }
    
    // Datepickerの初期化（設定ベース）
    async function initializeDatepicker() {
      // 祝日データとカートグループを先に読み込み
      await Promise.all([
        initializeHolidays(),
        getCurrentCartGroup().then(group => currentCartGroup = group)
      ]);
      
      if (Shopify.designMode) console.log('現在のカートグループ:', currentCartGroup);
      
      const today = normalizeDate(new Date());
      const earliestDelivery = getNextShippingDate(today, currentCartGroup);
      const deliveryRange = getDeliveryDateRange(earliestDelivery, currentCartGroup);
      
      // delivery-date要素が存在する場合のみdatepickerを初期化
      const $deliveryDateInput = $('#delivery-date');
      if ($deliveryDateInput.length > 0) {
        if (Shopify.designMode) console.log('datepickerを初期化中...');
        
        $deliveryDateInput.datepicker({
          dateFormat: 'yy-mm-dd',
          minDate: deliveryRange.min,
          maxDate: deliveryRange.max,
          beforeShowDay: function(date) {
            const validation = isDeliveryDateValid(date);
            
            if (!validation.valid) {
              return [false, 'delivery-unavailable', validation.reason];
            }
            
            return [true, 'delivery-available', '配達可能'];
          },
          onSelect: function(dateText) {
            $(this).trigger('change');
          },
          // 日本語化設定
          monthNames: ['1月', '2月', '3月', '4月', '5月', '6月',
                       '7月', '8月', '9月', '10月', '11月', '12月'],
          monthNamesShort: ['1月', '2月', '3月', '4月', '5月', '6月',
                            '7月', '8月', '9月', '10月', '11月', '12月'],
          dayNames: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'],
          dayNamesShort: ['日', '月', '火', '水', '木', '金', '土'],
          dayNamesMin: ['日', '月', '火', '水', '木', '金', '土'],
          showMonthAfterYear: true,
          yearSuffix: '年',
          changeMonth: true,
          changeYear: true,
          showButtonPanel: true,
          closeText: '閉じる',
          currentText: '今日',
          prevText: '&#x3C;前',
          nextText: '次&#x3E;'
        });
        
        if (Shopify.designMode) console.log('datepicker初期化完了');
        if (Shopify.designMode) console.log("datePicker min:", deliveryRange.min)
        if (Shopify.designMode) console.log("datePicker max:", deliveryRange.max)
      } else {
        if (Shopify.designMode) console.warn('delivery-date要素が見つからないため、datepickerは初期化されませんでした');
      }
    }

    // 配達方法選択の初期化
    function initializeDeliveryMethods() {
      if (Shopify.designMode) console.log('配達方法選択の初期化中...');
      
      // 配達方法ラジオボタンのイベントリスナー
      const deliveryMethodInputs = document.querySelectorAll('input[name="delivery-method"]');
      const fastestDeliveryInfo = document.getElementById('fastest-delivery-info');
      const calendarSelection = document.getElementById('calendar-selection');
      
      deliveryMethodInputs.forEach(input => {
        input.addEventListener('change', function() {
          
          if (this.value === 'fastest') {
            // 最速配達選択
            if (fastestDeliveryInfo) {
              if (Shopify.designMode) console.log(fastestDeliveryInfo);
              fastestDeliveryInfo.classList.remove('is-hidden');
            }
            if (calendarSelection) {
              if (Shopify.designMode) console.log(calendarSelection);
              calendarSelection.classList.add('is-hidden');
            }
            
            // 配送方法の属性を更新
            updateDeliveryMethodAttribute('fastest');
            
          } else if (this.value === 'calendar') {
            // カレンダー選択
            if (fastestDeliveryInfo) {
              if (Shopify.designMode) console.log(fastestDeliveryInfo);
              fastestDeliveryInfo.classList.add('is-hidden');
            }
            if (calendarSelection) {
              if (Shopify.designMode) console.log(calendarSelection);
              calendarSelection.classList.remove('is-hidden');
            }
            
            // 配送方法の属性を更新
            updateDeliveryMethodAttribute('calendar');
          }
        });
      });
      
      // 初期状態の設定
      const checkedMethod = document.querySelector('input[name="delivery-method"]:checked');
      if (checkedMethod) {
        checkedMethod.dispatchEvent(new Event('change'));
      }
    }

    // 配送方法属性の更新
    function updateDeliveryMethodAttribute(method) {
      const deliveryMethodInput = document.getElementById('delivery-method-type');
      if (deliveryMethodInput) {
        deliveryMethodInput.value = method;
      }
      
      // カート属性の更新
      updateCartAttributes();
    }
    
    // カート属性の更新
    function updateCartAttributes() {
      clearTimeout(updateTimer);
      updateTimer = setTimeout(function() {
        const $deliveryDateInput = $('#delivery-date');
        const $deliveryTimeInput = $('#delivery-time');
        const $fastestDeliveryTimeInput = $('#fastest-delivery-time');
        const $deliveryMethodInput = $('#delivery-method-type');
        
        const formData = new FormData();
        
        // 配送方法
        if ($deliveryMethodInput.length > 0) {
          formData.append('attributes[配送方法]', $deliveryMethodInput.val());
        }
        
        // 配送希望日
        if ($deliveryDateInput.length > 0 && $deliveryDateInput.val()) {
          formData.append('attributes[配送希望日]', $deliveryDateInput.val());
        }
        
        // 配送希望時間帯（カレンダー選択時）
        if ($deliveryTimeInput.length > 0 && $deliveryTimeInput.val()) {
          formData.append('attributes[配送希望時間帯]', $deliveryTimeInput.val());
        }
        
        // 配送希望時間帯（最速配達時）
        if ($fastestDeliveryTimeInput.length > 0 && $fastestDeliveryTimeInput.val()) {
          formData.append('attributes[配送希望時間帯]', $fastestDeliveryTimeInput.val());
        }
        
        fetch('/cart/update.js', {
          method: 'POST',
          body: formData
        })
        .then(function(response) {
          return response.json();
        })
        .then(function(data) {
        })
        .catch(function(error) {
          if (Shopify.designMode) console.error('カート属性の更新エラー:', error);
        });
      }, 500);
    }
    
    // カート属性の読み込み
    function loadCartAttributes() {
      fetch('/cart.js')
        .then(function(response) {
          return response.json();
        })
        .then(function(cart) {
          
          const $deliveryDateInput = $('#delivery-date');
          const $deliveryTimeInput = $('#delivery-time');
          const $fastestDeliveryTimeInput = $('#fastest-delivery-time');
          
          if (cart.attributes['配送希望日'] && $deliveryDateInput.length > 0) {
            $deliveryDateInput.val(cart.attributes['配送希望日']);
          }
          if (cart.attributes['配送希望時間帯']) {
            if ($deliveryTimeInput.length > 0) {
              $deliveryTimeInput.val(cart.attributes['配送希望時間帯']);
            }
            if ($fastestDeliveryTimeInput.length > 0) {
              $fastestDeliveryTimeInput.val(cart.attributes['配送希望時間帯']);
            }
          }
          if (cart.attributes['配送方法']) {
            const method = cart.attributes['配送方法'];
            const methodRadio = document.querySelector(`input[name="delivery-method"][value="${method}"]`);
            if (methodRadio) {
              methodRadio.checked = true;
              methodRadio.dispatchEvent(new Event('change'));
            }
          }
        })
        .catch(function(error) {
          if (Shopify.designMode) console.error('カート属性の読み込みエラー:', error);
        });
    }
    
    // イベントリスナーの追加（要素の存在をチェック）
    function attachEventListeners() {
      
      const $deliveryDateInput = $('#delivery-date');
      const $deliveryTimeInput = $('#delivery-time');
      const $fastestDeliveryTimeInput = $('#fastest-delivery-time');
      
      if ($deliveryDateInput.length > 0) {
        $deliveryDateInput.on('change', function() {
          updateCartAttributes();
        });
      }
      
      if ($deliveryTimeInput.length > 0) {
        $deliveryTimeInput.on('change', function() {
          if (Shopify.designMode) console.log('配送希望時間帯が変更されました:', $(this).val());
          updateCartAttributes();
        });
      }
      
      if ($fastestDeliveryTimeInput.length > 0) {
        $fastestDeliveryTimeInput.on('change', function() {
          updateCartAttributes();
        });
      }
    }

    // カート更新時の再初期化
    document.addEventListener('cart:updated', async function() {
      const newGroup = await getCurrentCartGroup();
      if (newGroup !== currentCartGroup) {
        currentCartGroup = newGroup;
        
        // datepickerを再初期化
        const $deliveryDateInput = $('#delivery-date');
        if ($deliveryDateInput.length > 0) {
          $deliveryDateInput.datepicker('destroy');
          await initializeDatepicker();
        }
        updateFastestDeliveryDate();
        updateDeliveryInfo();
      }
    });
    
    // 初期化の実行
    async function performInitialization() {
      
      try {
        // 配達方法選択の初期化
        initializeDeliveryMethods();
        
        // datepickerの初期化
        await initializeDatepicker();
        
        // 最速配達日の更新
        updateFastestDeliveryDate();
        
        // 配送情報の更新
        updateDeliveryInfo();
        
        // イベントリスナーの追加
        attachEventListeners();
        
        // カート属性の読み込み
        loadCartAttributes();
        
      } catch (error) {
        if (Shopify.designMode) console.error('初期化中にエラーが発生しました:', error);
      }
    }
    
    // 初期化の実行
    performInitialization();
  }
  
  // jQueryのready関数を使用（より安全な初期化）
  $(document).ready(function() {
    
    // jQuery UIが読み込まれているかチェック
    if (typeof $.fn.datepicker === 'undefined') {
      if (Shopify.designMode) console.error('jQuery UI Datepickerが読み込まれていません');
      return;
    }
    
    // 少し遅延させて確実に要素が存在するようにする
    setTimeout(function() {
      initializeDeliveryDate();
    }, 100);
  });
  
})(jQuery);